import React from "react";
import ProductCategoryButton from "../ProductCategoryButton";
import ClothingDropdown from "./ClothingDropdown";

interface DesktopProductCategoryButtonBarProps {
  sortedProductCategories: string[];
  selectedCategory: string;
  handleCategorySelect: (category: string | null) => void;
  showClothingDropdown: boolean;
  selectedClothingCategory: string;
  handleClothingCategorySelect: (category: string) => void;
  clothingCategoryCounts: {
    "Custom Hoodies": number;
    "Custom T-Shirts": number;
    "Custom Racerbacks": number;
  };
}

const DesktopProductCategoryButtonBar: React.FC<
  DesktopProductCategoryButtonBarProps
> = ({
  sortedProductCategories,
  selectedCategory,
  handleCategorySelect,
  showClothingDropdown,
  selectedClothingCategory,
  handleClothingCategorySelect,
  clothingCategoryCounts,
}) => {
  return (
    <div className="row justify-content-center d-none d-md-flex">
      {sortedProductCategories.map((item) => (
        <ProductCategoryButton
          key={item}
          item={item}
          selectedCategory={selectedCategory}
          handleCategorySelect={handleCategorySelect}
        />
      ))}
      {showClothingDropdown && (
        <div className="col-12 col-md-3 col-xl-2">
          <ClothingDropdown
            selectedCategory={selectedClothingCategory}
            onSelectCategory={handleClothingCategorySelect}
            categoryCounts={clothingCategoryCounts}
          />
        </div>
      )}
    </div>
  );
};

export default DesktopProductCategoryButtonBar;
